module.exports = __webpack_public_path__ + "static/media/WAREHOUSING.7e06abac.jpg";